import { TeamModel } from "./Team";

export class PitchingStatisticsModel {
    public year = '';
    public type = '';
    public w = '';
    public era = '';
    public so = '';
    public sv = '';
    public whip = '';
    public hbp = '';
    public ip = '';
    public l = '';
    public g = '';
    public cg = '';
    public sho = '';
    public er = '';
    public hr  = '';
    public r = '';
    public bb = '';
    public hld = '';
    public h = '';
    public gf = '';
    public s = '';
    public ab = '';
    public avg = '';
    public h2b = '';
    public h3b = '';
    public sb = '';
    public cs = '';
    public obp = '';
    public slg = '';
    public ops = '';
    public opponent: TeamModel = new TeamModel();
    public isHome = false;
    public date: Date = new Date();
    public get opp(): string {
        return (this.isHome ? '' : '@') + this.opponent.abbrU;
    }

    constructor(obj?: any) {
        if (obj) {
            this.era = typeof obj.era !== 'undefined' ? obj.era : '';
            this.w = typeof obj.w !== 'undefined' ? obj.w : '';
            this.l = typeof obj.l !== 'undefined' ? obj.l : '';
            this.g = typeof obj.g !== 'undefined' ? obj.g : '';
            this.s = typeof obj.s !== 'undefined' ? obj.s : '';
            this.h = typeof obj.h !== 'undefined' ? obj.h : '';
            this.r = typeof obj.r !== 'undefined' ? obj.r : '';
            this.er = typeof obj.er !== 'undefined' ? obj.er : '';
            this.bb = typeof obj.bb !== 'undefined' ? obj.bb : '';
            this.so = typeof obj.so !== 'undefined' ? obj.so : '';
            this.hr = typeof obj.hr !== 'undefined' ? obj.hr : '';
            this.sho = typeof obj.sho !== 'undefined' ? obj.sho : '';
            this.ip = typeof obj.ip !== 'undefined' ? obj.ip : '';
            this.hbp = typeof obj.hbp !== 'undefined' ? obj.hbp : '';
            this.cg = typeof obj.cg !== 'undefined' ? obj.cg : '';
            this.sv = typeof obj.sv !== 'undefined' ? obj.sv : '';
            this.whip = typeof obj.whip !== 'undefined' ? obj.whip : '';
            this.hld = typeof obj.hld !== 'undefined' ? obj.hld : '';
            this.gf = typeof obj.gf !== 'undefined' ? obj.gf : '';
            this.avg = typeof obj.avg !== 'undefined' ? obj.avg : '';
            this.h2b = typeof obj.h2b !== 'undefined' ? obj.h2b : '';
            this.h3b = typeof obj.h3b !== 'undefined' ? obj.h3b : '';
            this.sb = typeof obj.sb !== 'undefined' ? obj.sb : '';
            this.cs = typeof obj.cs !== 'undefined' ? obj.cs : '';
            this.obp = typeof obj.obp !== 'undefined' ? obj.obp : '';
            this.slg = typeof obj.slg !== 'undefined' ? obj.slg : '';
            this.ops = typeof obj.ops !== 'undefined' ? obj.ops : '';
            this.ab = typeof obj.ab !== 'undefined' ? obj.ab : '';
        }
    }

}